import React, { useState, useEffect } from 'react';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TextField,
  InputAdornment,
  Button,
  Box,
  Autocomplete,
  Card,
  Modal,
  MenuItem,
  IconButton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ShareIcon from '@mui/icons-material/Share';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ReplayIcon from '@mui/icons-material/Replay';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import statusImg from '../../../assets/status.png';
import { makeApiRequest } from '../../../utils/api';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useLocation } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function GeneratedCertificatesList({ initialData }) {
  const control = localStorage.getItem('control');
  const userLocation = localStorage.getItem('userLocation');
  const [formData, setFormData] = useState({
    location: (control == 4) ? userLocation : '',
    batch: '',
    name: '',
    startDate: '',
    endDate: ''
  });
  const [batches, setBatches] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState([]);
  const [email, setEmail] = useState('');
  const [view, setView] = useState(false);
  const [previewStudent, setPreviewStudent] = useState([]);
  const location = useLocation();
  const { startDate, endDate } = useState('');
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectDelete, setSelectDelete] = useState([]);

  const fetchBatchData = async () => {
    try {
      const response = await makeApiRequest('post', '/api/listBatches/active', {
        token: localStorage.getItem('authToken'),
      });
      if (response?.status === 'success' && response.data) {
        let data = response.data;
        if (control == 4 && userLocation) {
          data = data.filter(batch => Number(batch.location) === Number(userLocation));
        }
        setBatches(data);
      } else {
        setBatches([]);
      }
    } catch (err) {
      console.error("Error fetching batches:", err);
      setBatches([]);
    }
  };
  useEffect(() => {
    fetchBatchData();
  }, []);

  useEffect(() => {
    fetchStudentData();
  }, []);

  const fetchStudentData = async () => {
    try {
      // if (!formData.batch && !formData.location && !formData.name && (!formData.startDate || !formData.endDate)) {
      //   throw new Error('Please select any Fields');
      // }
      const response = await makeApiRequest('post', '/api/certificate/index', {
        token: localStorage.getItem('authToken'),
        filters: formData
      });

      if (response.status === "success") {
        setSearchResults(response.data);
      } else {
        setSearchResults([]);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      toast.error(err.message);
      setSearchResults([]);
    }
  };



  function getDepartmentNameById(id) {
    const departments = {
      1: 'Architecture',
      6: 'Chemical',
      3: 'Civil',
      4: 'Electrical',
      9: 'L&D',
      2: 'Mechanical',
      7: 'Petrochemical',
      8: 'Petroleum',
      5: 'Structural',
    };

    return departments[id] || 'Unknown Department';
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleShare = (row) => {
    setModalOpen(true);
    setSelectedStudent(row)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleRetry = async (id) => {
    try {
      const response = await makeApiRequest('post', '/api/certificate/update/status', {
        token: localStorage.getItem('authToken'),
        id: id,
        status: "incomplete"
      });
      if (response.status == "success") {
        toast.success("Please Regenerate the Certificate");
        fetchStudentData();
      }
    }
    catch (err) {
      console.error("Error fetching data:", err);
      toast.error('Retry failed. Please try again.');
    }
  }
  const handleCloseViewModal = () => {
    setModalOpen(false);
  }
  useEffect(() => {
    if (selectedStudent?.email) {
      setEmail(selectedStudent.email);
    }
  }, [selectedStudent]);
  const handleShareEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handleAction = (row) => {
    setView(true);
    setPreviewStudent(row);
  }
  const handleCloseView = () => {
    setView(false);
  }
  useEffect(() => {
    if (selectedStudent?.email) {
      setEmail(selectedStudent.email);
    }
  }, [selectedStudent]);
  const checkStatus = async (id) => {
    try {
      const response = await makeApiRequest('post', '/api/certificate/status', {
        token: localStorage.getItem('authToken'),
        userid: id
      });
      if (response.status == "success") {
        toast.info(response.data);
      }
      fetchStudentData();
    }
    catch (err) {
      console.error("Error fetching data:", err);
      toast.error('Retry failed. Please try again.');
    }
  }
  const shareCertificate = async (userid) => {
    try {
      const emailArray = email
        .split(',')
        .map(e => e.trim())
        .filter(e => e.length > 0);

      const response = await makeApiRequest('post', '/api/certificate/mail', {
        token: localStorage.getItem('authToken'),
        userid: userid,
        emails: emailArray
      });

      if (response.status === "success") {
        toast.success(response.message);
      }

      setModalOpen(false);
      fetchStudentData();
    } catch (err) {
      console.error("Error sending emails:", err);
      toast.error('Retry failed. Please try again.');
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await makeApiRequest('post', '/api/certificate/delete', {
        token: localStorage.getItem('authToken'),
        id: id
      });
      if (response.status == "success") {
        toast.success("Data deleted succesfully");
      }
      setDeleteModalOpen(false);
      setView(false);
      setModalOpen(false);
      fetchStudentData();

    }
    catch (err) {
      console.error("Error fetching data:", err);
    }
  }
  const handleCancelDelete = () => {
    setDeleteModalOpen(false);
  };
  const handelOpenDelete = (student) => {
    setSelectDelete(student)
    setDeleteModalOpen(true);
  }
  const handleDownload = async (pdfUrl) => {
    try {
      const response = await fetch(pdfUrl, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to download file.');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;

      const filename = pdfUrl.split('/').pop() || 'download.pdf';
      link.setAttribute('download', filename);

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download the file.');
    }
  };


  return (
    <Box sx={{ padding: '20px', backgroundColor: '#F1F4F9', minHeight: '100vh' }}>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
      <Typography variant="h4" style={{ marginLeft: '30px', color: '#481E82', fontSize: '34px', fontFamily: ' sans-serif' }}>
        View Certificates
      </Typography>
      <Card
        sx={{
          p: 3,
          m: 2,
          mr: 4,
          ml: 4,
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'flex-start',
          alignItems: 'center',
          width: 'auto',
          '@media (max-width: 768px)': {
            flexDirection: 'column',
            alignItems: 'stretch',
          },
        }}
      >
        <TextField
          size="small"
          label="Location"
          variant="outlined"
          select
          value={formData.location}
          disabled={control == 4}
          onChange={(e) => setFormData({ ...formData, location: e.target.value })}
          sx={{ width: 250, fontFamily: 'sans-serif' }}
          InputLabelProps={{ shrink: true }}
        >
          <MenuItem value="1">Chennai</MenuItem>
          <MenuItem value="2">Trichy</MenuItem>
        </TextField>
        <Autocomplete
          disablePortal
          options={batches}
          getOptionLabel={(option) => option.batch_name || ''}
          value={batches.find((batch) => batch.id === formData.batch) || null}
          onChange={(event, newValue) => {
            setFormData({ ...formData, batch: newValue ? newValue.id : '' });
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disableClearable
          renderInput={(params) => (
            <TextField
              {...params}
              label="Batch"
              placeholder="Select Batch"
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          )}
          sx={{ width: 250, fontFamily: 'sans-serif' }}
        />
        <TextField
          label="Generated From"
          type="date"
          size="small"
          value={formData.startDate}
          onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CalendarTodayIcon />
              </InputAdornment>
            ),
          }}
          sx={{ width: 180 }}
        />
        <TextField
          label="Generated To"
          type="date"
          size="small"
          value={formData.endDate}
          onChange={(e) => setFormData({ ...formData, endDate: e.target.value })}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CalendarTodayIcon />
              </InputAdornment>
            ),
          }}
          sx={{ width: 180 }}
        />
        <TextField
          size="small"
          label="Search"
          placeholder="Student name or ID"
          variant="outlined"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          sx={{ width: 230, fontFamily: 'sans-serif' }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={fetchStudentData}
          style={{ width: '150px', fontFamily: 'sans-serif', height: '40px' }}
        >
          Search
        </Button>
      </Card>

      <Card sx={{ ml: 4, mr: 4 }}>
        <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
          <Table sx={{ minWidth: 650 }} aria-label="generated certificates table">
            <TableHead sx={{ backgroundColor: '#E0F7FA' }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem', textAlign: 'left' }}>S no</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem', textAlign: 'left' }}>Student Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem', textAlign: 'left' }}>Email</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem', textAlign: 'left' }}>Department</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem', textAlign: 'left' }}>Batch / Course</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem', textAlign: 'center' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem', textAlign: 'center' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {searchResults.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell sx={{ textAlign: 'left' }}>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell sx={{ textAlign: 'left' }}>
                    <Box>{row.student_name}</Box>
                    <Box sx={{ color: 'grey', fontSize: '0.8rem' }}>{row.user_id}</Box>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'left', color: '#1976D2', textDecoration: 'underline', cursor: 'pointer' }}>
                    <a href={`mailto:${row.email}`} style={{ color: 'inherit', textDecoration: 'inherit' }}>
                      {row.email}
                    </a>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'left' }}>{getDepartmentNameById(row.dept)}</TableCell>
                  <TableCell sx={{ textAlign: 'left' }}>
                    <Box>{row.batch}</Box>
                    <Box sx={{ color: 'grey', fontSize: '0.8rem' }}>{row.course}</Box>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    {row.shared_status ? (
                      <Button
                        sx={{
                          backgroundColor: '#64e45d', color: '#ffffff', width: '107px',
                          '&.Mui-disabled': {
                            backgroundColor: '#03b125',
                            color: '#ffffff',
                          }
                        }}
                        disabled
                        size="small"
                        variant="contained"
                        startIcon={<CheckCircleIcon />}
                      >
                        Shared
                      </Button>
                    ) : row.generated_status === 'completed' ? (
                      <Button
                        sx={{
                          backgroundColor: '#64e45d', color: '#ffffff', width: '107px',
                          '&.Mui-disabled': {
                            backgroundColor: '#64e45d',
                            color: '#ffffff',
                          }
                        }}
                        size="small"
                        variant="contained"
                        disabled
                        startIcon={<CheckCircleOutlineIcon />}
                      >
                        Success
                      </Button>
                    ) : row.generated_status === 'failed' ? (
                      <Button
                        sx={{
                          backgroundColor: '#f2ab55', color: '#ffffff', width: '107px',
                          '&.Mui-disabled': {
                            backgroundColor: '#f2ab55',
                            color: '#ffffff',
                          }
                        }}
                        size="small"
                        variant="contained"
                        disabled
                        startIcon={<ReplayIcon />}
                      >
                        Failed
                      </Button>
                    ) : (
                      <Button
                        sx={{
                          backgroundColor: '#D2B7E5', color: '#ffffff', width: '107px',
                          '&.Mui-disabled': {
                            backgroundColor: '#D2B7E5',
                            color: '#ffffff',
                          }
                        }}
                        size="small"
                        disabled
                        variant="contained"
                        startIcon={<PendingActionsIcon />}
                      >
                        Pending
                      </Button>
                    )}
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    {row.shared_status ? (
                      <IconButton>
                        <VisibilityIcon color="primary" onClick={() => handleAction(row)} />
                      </IconButton>
                    ) : row.generated_status === 'completed' ? (
                      <IconButton>
                        <ShareIcon color="primary" onClick={() => handleShare(row)} />
                      </IconButton>
                    ) : row.generated_status === 'failed' ? (
                      <IconButton>
                        <ReplayIcon color="primary" onClick={() => handleRetry(row.id)} />
                      </IconButton>
                    ) : (
                      <IconButton>
                        <RefreshIcon onClick={() => checkStatus(row.user_id)} />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={searchResults.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </Card>
      {/*share Modal
*/}
      <Modal
        open={modalOpen}
        onClose={handleCloseViewModal}
        aria-labelledby="view-certificate-modal"
        aria-describedby="modal-to-view-and-share-certificate"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            width: '45%',
            '@media (max-width: 768px)': {
              width: '95%',
            },
            maxWidth: '95vw',
            maxHeight: '95vh',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography id="view-certificate-modal" variant="h6" component="h2">
              <>
                <Box sx={{ fontWeight: 'bold', color: 'black', display: 'inline' }}>
                  {selectedStudent.student_name}
                </Box>
                {' - '}
                <Box sx={{ color: 'grey', display: 'inline' }}>
                  {selectedStudent.user_id}
                </Box>
              </>
            </Typography>
            <IconButton>
              <CloseIcon onClick={handleCloseViewModal} />
            </IconButton>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Typography sx={{ fontWeight: 'bold', mr: 1 }}>To:</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                value={email}
                onChange={handleShareEmailChange}
                InputProps={{
                  inputProps: {
                    style: { color: '#1976D2' },
                  },
                }}
              />
            </Box>

            <Typography sx={{ color: 'grey', fontSize: '1rem', mt: -1, mb: 1 }}>
              <strong style={{ color: 'black' }}>Note:</strong> To share with recipients not listed, you can add their email address by a comma.
            </Typography>

            <Box
              sx={{
                display: 'flex',
                backgroundColor: '#E8F0F7',
                padding: '20px',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 1,
              }}
            >
              <img
                src={`${process.env.REACT_APP_API_URL}/${selectedStudent.first_page_path}`}
                alt="Certificate"
                style={{
                  maxWidth: selectedStudent.second_page_path ? '50%' : '100%',
                  height: 'auto',
                  marginRight: '8px',
                  objectFit: 'contain',
                }}
              />
              {selectedStudent.second_page_path && (
                <img
                  src={`${process.env.REACT_APP_API_URL}/${selectedStudent.second_page_path}`}
                  alt="Assessment Report"
                  style={{
                    maxWidth: '50%',
                    height: 'auto',
                    marginRight: '8px',
                    objectFit: 'contain',
                  }}
                />
              )}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
              <Button
                variant="contained"
                sx={{ mr: 1, bgcolor: '#F2AB55', '&:hover': { bgcolor: '#F2AB55' } }}
                onClick={() => handleDownload(selectedStudent.pdf_path)}
              >
                DOWNLOAD
              </Button>
              {control == 1 && (
                <Button
                  variant="contained"
                  sx={{ mr: 1, bgcolor: '#FF4D6D', '&:hover': { bgcolor: '#ff3357' } }}
                  onClick={() => handelOpenDelete(selectedStudent)}
                >
                  DELETE
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                onClick={() => shareCertificate(selectedStudent.user_id)}
              >
                SHARE
              </Button>

            </Box>
          </Box>
        </Box>
      </Modal>
      {/*view Modal
*/}
      <Modal
        open={view}
        onClose={handleCloseView}
        aria-labelledby="view-certificate-modal"
        aria-describedby="modal-to-view-and-share-certificate"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            width: '50%',
            '@media (max-width: 768px)': {
              width: '95%',
            },
            height: '77%',
            maxWidth: '200vw',
            maxHeight: '200vh',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, backgroundColor: '#E0F7FA' }}>
            <Typography id="view-certificate-modal" variant="h6" component="h2">
              <>
                <Box sx={{ fontWeight: 'bold', color: 'black', display: 'inline', marginRight: '5px', marginLeft: '5px' }}>
                  {previewStudent.student_name}
                </Box>
                {' - '}
                <Box sx={{ color: 'grey', display: 'inline' }}>
                  {previewStudent.user_id}
                </Box>
              </>
            </Typography>
            <IconButton>
              <CloseIcon onClick={handleCloseView} />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: 'flex',
              backgroundColor: '#E8F0F7',
              padding: '20px',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 1,
              paddingTop: '10px'
            }}
          >
            <img
              src={`${process.env.REACT_APP_URL}/${previewStudent.first_page_path}`}
              alt="Certificate"
              style={{ maxHeight: '450px', width: 'auto', marginRight: '8px' }}
            />
            {previewStudent.second_page_path && (
              <img
                src={`${process.env.REACT_APP_URL}/${previewStudent.second_page_path}`}
                alt="Assessment Report"
                style={{ maxHeight: '450px', width: 'auto' }}
              />
            )}
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
            <Button
              variant="contained"
              sx={{ mr: 1, bgcolor: '#F2AB55', '&:hover': { bgcolor: '#F2AB55' } }}
              onClick={() => handleDownload(previewStudent.pdf_path)}
            >
              DOWNLOAD
            </Button>
            {control == 1 && (
              <Button
                variant="contained"
                sx={{ mr: 1, bgcolor: '#FF4D6D', '&:hover': { bgcolor: '#ff3357' } }}
                onClick={() => handelOpenDelete(previewStudent)}
              >
                DELETE
              </Button>
            )}
          </Box>
        </Box>
      </Modal>
      {/*delete Modal
*/}
      <Modal
        open={deleteModalOpen}
        onClose={handleCancelDelete}
        aria-labelledby="delete-confirmation-modal-title"
        aria-describedby="delete-confirmation-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '30%',
          '@media (max-width: 768px)': {
            width: '95%',
          },
          bgcolor: 'white',
          boxShadow: 24,
          borderRadius: 2,
          textAlign: 'center',
        }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mt: 4,
            mb: 2,
          }}>
            <Box sx={{
              backgroundColor: '#FF4D6D',
              color: 'white',
              width: '85%',
              p: 1.5,
              borderRadius: '2px',
              textAlign: 'left',
            }}>
              <Typography variant="h6" component="h2" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                CONFIRM DELETE
              </Typography>
            </Box>
          </Box>
          <Box sx={{ p: 3 }}>
            <Typography id="delete-confirmation-modal-description" sx={{ mb: 3, marginTop: -2, textAlign: 'left', fontSize: '1rem', lineHeight: '1.5' }}>
              <Typography sx={{ mt: -4, color: 'black', lineHeight: '2', fontSize: '1.2rem' }}>
                Are you sure you want to delete this certificate?
              </Typography>
              <Typography sx={{ color: 'grey', lineHeight: '1.5', fontSize: '1.2rem' }}>
                If you proceed, this certificate will be deleted,
              </Typography>
              <Typography sx={{ color: 'grey', lineHeight: '1.5', fontSize: '1.2rem', mb: 2 }}>
                and you will need to start the certificate
              </Typography>
              <Typography sx={{ color: 'grey', lineHeight: '0.5', fontSize: '1.2rem', mb: 2, mt: -1 }}>
                generation process again to regenerate it..
              </Typography>
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <Button
                variant="outlined"
                onClick={handleCancelDelete}
                sx={{ color: '#FF9800', borderColor: '#FF9800' }}
              >
                CANCEL
              </Button>
              <Button
                variant="contained"
                onClick={() => handleDelete(selectDelete.id)}
                style={{ backgroundColor: '#FF4D6D' }}
              >
                DELETE
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default GeneratedCertificatesList;